import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageFaq = lazy(() => import("./layout/index"));

export const routerPageFaq: RouterItemType = {
  path: "/support/faq",
  authorize: false,
  element: <LayoutPageFaq />,
};
